// @flow
export const REFRESH_SEARCH = 'search/REFRESH_SEARCH';
export const SET_SEARCH_STRING = 'search/SET_SEARCH_STRING';
export const SET_SUGGEST_STRING = 'search/SET_SUGGEST_STRING';

export function refreshSearch() {
    return {
        type: REFRESH_SEARCH,
    };
}

export function setSearchString( searchString ) {
    return {
        type: SET_SEARCH_STRING,
        searchString
    };
}

export function setSuggestString( suggestString ) {
    return {
        type: SET_SUGGEST_STRING,
        suggestString
    };
}

